import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './utils/authSessionGuard';
import './utils/axiosSessionGuard';

// Fix Leaflet default marker icons not showing (Webpack breaks the default icon paths)
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
});

// Leaflet 1.9.x bug workaround: `_animateZoom` schedules a 250ms fallback
// timer (webkit transitionend workaround) that Map#remove() never cancels.
// If a map is unmounted within that window (e.g. a React tab/toggle removes
// the MapContainer right after a zoom), the timer still fires and
// `_onZoomTransitionEnd` unconditionally calls `_move()`, which dereferences
// `_mapPane` after `remove()` already deleted it — throwing
// "Cannot read properties of undefined (reading '_leaflet_pos')" app-wide on
// every page that uses react-leaflet. Bail out instead of crashing when the
// map has already been torn down.
const originalOnZoomTransitionEnd = L.Map.prototype._onZoomTransitionEnd;
L.Map.prototype._onZoomTransitionEnd = function (...args) {
    if (!this._mapPane) {
        this._animatingZoom = false;
        return;
    }
    return originalOnZoomTransitionEnd.apply(this, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
